



















import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import CustomChart from "@/components/CustomChart.vue";
import NoCache from "@/decorators/NoCache";

@Component({
  components: {
    CustomChart,
  },
})
export default class TimeDistribution extends Vue {
  @Prop({ default: () => [] }) readonly values!: number[];
  @Prop({ default: 15 }) readonly margin!: number;
  @Prop({ default: null }) readonly width?: number | null;
  @Prop({ default: () => [] }) readonly vodValues!: number[];
  @Prop({ default: false }) readonly showVodCheck!: boolean;

  @Ref() readonly container?: HTMLDivElement;

  @NoCache
  get containerWidth() {
    return this.container?.clientWidth || 1;
  }

  @NoCache
  get containerHeight() {
    return this.container?.clientHeight || 1;
  }

  mounted() {
    this.$forceUpdate();
  }

  barHeight(value: number) {
    return (value * this.containerHeight) / this.maxValue + 1;
  }

  get totalValue() {
    return this.values.reduce((c, v) => c + v, 0);
  }

  get maxValue() {
    return Math.max(...this.values, 1);
  }

  barStyle(index: number, value: number) {
    const data = {
      width: `${this.barWidth}px`,
      height: `${this.barHeight(value) - 5}px`,
      "margin-left": `${this.margin}px`,
    };

    if (index > 0) {
      data["margin-left"] = `${this.margin}px`;
    }

    return data;
  }

  checkboxStyle(index: number, value: number) {
    const data = {
      top: "45%",
      "margin-left": `${this.margin + 1}px`,
    };

    if (index > 0) {
      data["margin-left"] = `${this.margin + 1}px`;
    }

    return data;
  }

  @NoCache
  get barWidth() {
    if (!this.containerWidth) {
      return 0;
    }
    if (!this.width) {
      return (this.containerWidth - this.margin) / this.values.length;
    } else {
      if (
        (this.width + this.margin) * this.values.length <=
        this.containerWidth
      ) {
        return this.width;
      } else {
        return (this.containerWidth - this.margin) / this.values.length;
      }
    }
  }

  get chartData() {
    return this.values?.map((o) => {
      return { data: [o] };
    });
  }

  getTooltipOptions(value: number, vodValue: number) {
    const data = {
      content: `${value}${this.valueToPercentString(value)}`,
      placement: "bottom",
      offset: 0,
    };
    if (vodValue >= 1) {
      data.content += "\n VOD:" + vodValue;
    }
    return data;
  }

  private valueToPercentString(value: number): string {
    if (!this.totalValue) {
      return "";
    }

    return ` (${Math.round((value / this.totalValue) * 100)})%`;
  }
}
